import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import classes from '../products.module.scss';
import Loader from '../../../_common/Loader/Loader';
import Pagination from '../../../_common/Pagination/Pagination';
import utils from '../../../../utils/utils';
import { ReactComponent as TimeIcon } from '../../../../assets/icons/time.svg';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons/arrow_sort.svg';

const header = [
  {
    name: 'Name',
    path: 'name',
    isSelectable: true,
  },
  {
    name: 'NDC',
    path: 'NDC',
    isSelectable: true,
  },
  {
    name: 'Schedule',
    path: 'schedule',
    isSelectable: true,
  },
  {
    name: 'Package size',
    path: 'packageSize',
    isSelectable: true,
  },
  {
    name: 'Quantity on hand',
    path: 'quantity',
    isSelectable: true,
  },
  {
    name: 'Unit Cost',
    path: 'unitPrice',
    type: 'currency',
    isSelectable: true,
  },
  {
    name: 'Total Cost',
    path: 'cost',
    type: 'currency',
    isSelectable: true,
  },
  {
    name: 'Actions',
    path: 'Actions',
  },
];

const ProductsTable = ({
  data, page, limit, totalPage, onChange, otc, sort, sortBy, onSortBy, loading,
}) => {
  const navigate = useNavigate();

  const [innerLoading, setInnerLoading] = useState(false);

  const showLoading = loading || innerLoading;

  const onChangeLoading = async (path, count) => {
    setInnerLoading(true);
    await onChange(path, count);
    setInnerLoading(false);
  };

  const onSort = (currentSortBy) => {
    const newSortType = { sortBy: currentSortBy, sort: 'asc' };

    if (sortBy === currentSortBy) {
      newSortType.sort = sort === 'desc' ? 'asc' : 'desc';
    }

    onSortBy(newSortType);
  };

  const arrowIcon = [classes.arrow_icon];
  if (sort === 'desc') arrowIcon.push(classes.arrow_icon_desc);

  return (
    !data.length && !showLoading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.table_pagination_wrapper}>
          <div className={classes.table_wrapper}>
            <table>
              { showLoading && <Loader />}

              <thead>
                <tr>
                  {header.map((h) => (
                    <th
                      key={h.name}
                      className={h.isSelectable ? classes.th_selectable : null}
                      onClick={() => h.isSelectable && onSort(h.path)}
                    >
                      <span className={classes.th_title}>
                        {h.name}

                        <span className={classes.th_arrow}>
                          {h.isSelectable && h.path === sortBy && (
                            <ArrowIcon className={arrowIcon.join(' ')} />
                          )}
                        </span>
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {data.map((d) => (
                  <tr key={d.id}>
                    {header.map((h) => (
                      h.path === 'Actions'
                        ? (
                          <td key={h.name} onClick={() => navigate(`${d.id}/inventory`)}>
                            <TimeIcon className={classes.icon} />
                          </td>
                        )

                        : (
                          <td
                            onClick={() => navigate(`${d.id}/edit?otc=${otc}`)}
                            key={h.name}
                          >
                            { h.type === 'currency'
                              ? utils.formattingCurrency(d[h.path])

                              : d[h.path] ? d[h.path] : '-'}
                          </td>
                        )
                    ))}

                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />

        </div>
      ));
};

ProductsTable.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  otc: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  totalPage: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  sortBy: PropTypes.string,
  sort: PropTypes.string,
  onSortBy: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ProductsTable.defaultProps = {
  sortBy: '',
  sort: '',
  loading: false,
};

export default ProductsTable;
